import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import craigbeaur from '../images/productpage/craig-beaur-profile.png'
import quoteyellow from '../images/svgs/quote-yellow.svg'

export default function Testimonial(props) {
    const { product } = props
    const { testimonial } = product
    if(!testimonial) return
    return (
        <div className='bg-white p-3 mt-4 mb-5'>
            <Row>
                <Col xs='auto' className='position-relative'>
                    <img src={craigbeaur} alt='' />
                    <img src={quoteyellow} alt='' className='position-absolute top-0' style={{ right: 12 }} />
                </Col>
                <Col>
                    <p style={{ fontSize: 12 }}><em>"Air Delay Pro is phenomenal. The depth of sounds possible is refreshing... to say the least. If you love delays and want something special then check this out!"</em></p>
                    <p style={{ fontSize: 12 }} className='text-uppercase ff-primary fw-bold mb-0'>Craig Beaur</p>
                    <p style={{ fontSize: 12 }} className='mb-0'>Grammy Award Winning Mixer: Kanye West, Rihanna, Justin Timberlake</p>
                </Col>
            </Row>
        </div>
    )
}